import {getFilenameFromHeaders} from '../../utils';
import {API} from '../types';

type GetPCFStaffsParams = {
  _start: number;
  _limit: number;
  _sort: any;
  medicalExpiredAt_lt?: string;
  export_csv: boolean;
};
interface Response {
  content: string;
  filename: string;
}

export function exportRsAPI(params: GetPCFStaffsParams): API<Response> {
  const urlParams = {
    ...params,
  };
  return {
    getData: async client => {
      const {headers, data} = await client({
        url: '/profiles/relief-staffs',
        method: 'GET',
        params: urlParams,
      });

      const filename = getFilenameFromHeaders(headers);

      return {
        data: {
          content: data,
          filename,
        },
      };
    },
    getMockData: () => {
      return {content: 'content', filename: 'filename'};
    },
  };
}
